export const projects = [
  {
    id: 'werksviertel-mk7',
    title: 'Werksviertel MK7',
    subtitle: 'Gewerblicher Innenausbau',
    location: 'München',
    category: 'neubau',
    description: 'Hochwertiger Innenausbau im Werksviertel München — ein modernes Gewerbeprojekt mit höchsten Ansprüchen an Qualität und Design. Kompletter Trockenbau, Bodenbeläge und Malerarbeiten auf über 800 m².',
    details: [
      'Fläche: ca. 800 m²',
      'Trockenbau & Akustikdecken',
      'Designbodenbeläge',
      'Malerarbeiten & Spachteltechnik',
      'Elektro- & Sanitärinstallation',
    ],
    duration: '4 Monate',
    year: '2024',
    image: null,
    gradient: 'linear-gradient(135deg, #1B2D42 0%, #2A4562 100%)',
  },
  {
    id: 'maisach-gernlinden',
    title: 'Maisach-Gernlinden',
    subtitle: 'Wohnungsbau — Neubau',
    location: 'Maisach-Gernlinden',
    category: 'neubau',
    description: 'Kompletter Innenausbau eines Neubau-Wohnprojekts in Maisach-Gernlinden. Mehrere Wohneinheiten mit individueller Ausstattung und hochwertigen Materialien.',
    details: [
      'Mehrere Wohneinheiten',
      'Individuelle Grundrisse',
      'Parkett- & Fliesenverlegung',
      'Bäder komplett',
      'Malerarbeiten',
    ],
    duration: '6 Monate',
    year: '2024',
    image: null,
    gradient: 'linear-gradient(135deg, #D1BC8A 0%, #B8A06E 100%)',
  },
  {
    id: 'cafe-nido',
    title: 'Café Nido',
    subtitle: 'Gastronomie-Ausbau',
    location: 'München',
    category: 'umbau',
    description: 'Umbau und Innenausbau des Café Nido in München — ein gemütliches Gastronomie-Konzept mit warmen Farben, hochwertigem Interieur und funktionaler Raumaufteilung.',
    details: [
      'Gastronomie-Konzept',
      'Theken- & Einbaumöbelbau',
      'Wand- & Deckengestaltung',
      'Beleuchtungskonzept',
      'Bodenbeläge & Fliesen',
    ],
    duration: '3 Monate',
    year: '2023',
    image: null,
    gradient: 'linear-gradient(135deg, #8B6914 0%, #D1BC8A 100%)',
  },
  {
    id: 'wohnungssanierung',
    title: 'Wohnungssanierung',
    subtitle: 'Komplettsanierung',
    location: 'München',
    category: 'sanierung',
    description: 'Komplettsanierung einer Bestandswohnung in München — von der Entkernung bis zur schlüsselfertigen Übergabe. Neue Bäder, Böden, Elektrik und moderne Raumgestaltung.',
    details: [
      'Komplett-Entkernung',
      'Neue Bäder mit Designfliesen',
      'Parkettverlegung',
      'Neue Elektroinstallation',
      'Hochwertige Malerarbeiten',
    ],
    duration: '3 Monate',
    year: '2023',
    image: null,
    gradient: 'linear-gradient(135deg, #2A4562 0%, #1B2D42 100%)',
  },
  {
    id: 'wohnungsumbau',
    title: 'Wohnungsumbau',
    subtitle: 'Grundrissänderung & Modernisierung',
    location: 'München',
    category: 'umbau',
    description: 'Umfassender Wohnungsumbau mit Grundrissänderung — offene Wohnküche, neues Bad und moderne Raumaufteilung. Aus einer klassischen Altbauwohnung wurde ein zeitgemäßes Zuhause.',
    details: [
      'Grundrissänderung',
      'Offene Wohnküche',
      'Neues Badezimmer',
      'Trockenbau & Ständerwerk',
      'Komplette Neugestaltung',
    ],
    duration: '2,5 Monate',
    year: '2024',
    image: null,
    gradient: 'linear-gradient(135deg, #1D2C38 0%, #D1BC8A 100%)',
  },
];

export const projectCategories = [
  { value: 'all', label: 'Alle Projekte' },
  { value: 'neubau', label: 'Neubau' },
  { value: 'umbau', label: 'Umbau' },
  { value: 'sanierung', label: 'Sanierung' },
];
